import { render } from "./RouteThumbnail.vue?vue&type=template&id=26950f60&scoped=true"
import script from "./RouteThumbnail.vue?vue&type=script&lang=ts"
export * from "./RouteThumbnail.vue?vue&type=script&lang=ts"

import "./RouteThumbnail.vue?vue&type=style&index=0&id=26950f60&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-26950f60"

export default script